import { render, staticRenderFns } from "./zygl.vue?vue&type=template&id=fd97e2b4&scoped=true"
import script from "./zygl.vue?vue&type=script&lang=js"
export * from "./zygl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd97e2b4",
  null
  
)

export default component.exports